import { render, staticRenderFns } from "./ScreenReactions.vue?vue&type=template&id=cf832144&scoped=true"
import script from "./ScreenReactions.vue?vue&type=script&lang=js"
export * from "./ScreenReactions.vue?vue&type=script&lang=js"
import style0 from "./ScreenReactions.vue?vue&type=style&index=0&id=cf832144&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf832144",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf832144')) {
      api.createRecord('cf832144', component.options)
    } else {
      api.reload('cf832144', component.options)
    }
    module.hot.accept("./ScreenReactions.vue?vue&type=template&id=cf832144&scoped=true", function () {
      api.rerender('cf832144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ScreenReactions.vue"
export default component.exports